import React from 'react';
import { Box } from '@mui/material';
import { getCadStockColor } from '../utils/cadStockStatus';
import { getCadStockLabel } from '../utils/cadParcelDisplay';

/**
 * Estado de lote CAD: puntito del overlay + label.
 * @param {object} props
 * @param {string} [props.status]
 */
export default function CadStockStatusLabel({ status }) {
  const resolved = status || 'available';
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        minWidth: 0,
        maxWidth: '100%',
        verticalAlign: 'middle',
      }}
    >
      <Box
        component="span"
        aria-hidden
        sx={{
          width: 8,
          height: 8,
          minWidth: 8,
          borderRadius: '50%',
          bgcolor: getCadStockColor(resolved),
          flexShrink: 0,
        }}
      />
      <Box
        component="span"
        sx={{
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {getCadStockLabel(resolved)}
      </Box>
    </Box>
  );
}
